import SlimSelect from 'slim-select'

document.querySelectorAll('.in-select').forEach(select => {
  let search
  if (select.classList.contains("--has-search")) {
    search = true
  } else {
    search = false
  }
  new SlimSelect({
    select: select,
    showSearch: search,
    selected: false,
    placeholder: false,
    settings: {
      searchPlaceholder: 'Vyhledat',
    },
    events: {
      afterChange: () => {
        transformLabel(select)
      },
    }
  });

});

const transformLabel = (select) => {
  const label = select.parentElement.querySelector(".in-label")
  console.log(label)
  label.classList.add("--visited")
}
